/**
 * VA-28665 — mapping between the admin VAD-settings API (`barge_in_*` keys) and the barge-in
 * config the detector uses. Pure, so the admin panel's round trip is unit-tested.
 */
import { DEFAULT_BARGE_IN_CONFIG, normalizeBargeInConfig, } from '@/context/barge-in-config';
export const fromAdminSettings = (settings) => settings
    ? normalizeBargeInConfig({
        probability: settings.barge_in_probability,
        onset_ms: settings.barge_in_onset_ms,
        abandon_ms: settings.barge_in_abandon_ms,
        max_window_ms: settings.barge_in_max_window_ms,
        min_level_dbfs: settings.barge_in_min_level_dbfs,
    })
    : Object.assign({}, DEFAULT_BARGE_IN_CONFIG);
export const toAdminPayload = (config) => {
    const c = normalizeBargeInConfig(config);
    return {
        barge_in_probability: c.probability,
        barge_in_onset_ms: c.onset_ms,
        barge_in_abandon_ms: c.abandon_ms,
        barge_in_max_window_ms: c.max_window_ms,
        barge_in_min_level_dbfs: c.min_level_dbfs,
    };
};
/** A plain-language read of the floor, for the panel. */
export const describeFloor = (dbfs) => dbfs <= -100
    ? 'Off — any voice-like sound counts, however quiet'
    : `Quieter than ${dbfs} dBFS is ignored`;
